
<template>
    <transition name="fade-in" mode="out-in" appear>
        <nav class="quicklink__wrapper" v-if="areas">
            <NavQuicklink
                v-for="link in areas"
                v-bind="link"
                :key="`${link.name}-${link.path}-${Math.random()}`"
            />
        </nav>
    </transition>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState('Resources', ['areas'])
    }
}
</script>

